export const WEB_SEARCH_PROVIDERS = ["brave", "exa", "tavily", "openai"] as const;
export type WebSearchProvider = (typeof WEB_SEARCH_PROVIDERS)[number];

export const WEB_SEARCH_PREFIX = "search-";

export function webSearchColumn(provider: WebSearchProvider): string {
  return `${WEB_SEARCH_PREFIX}${provider}`;
}

export function webSearchProviderIn(column: unknown): WebSearchProvider | null {
  if (typeof column !== "string" || !column.startsWith(WEB_SEARCH_PREFIX)) return null;
  const said = column.slice(WEB_SEARCH_PREFIX.length);
  return WEB_SEARCH_PROVIDERS.find((provider) => provider === said) ?? null;
}

export function isAWebSearchCredential(column: unknown): boolean {
  return typeof column === "string" && column.startsWith(WEB_SEARCH_PREFIX);
}
